import WhiteLayout from '../../WhiteLayout';
import en from '../../../../lang/en-us';
import { useFormik } from 'formik';
import { BANK } from '../../../../redux-store/types/nct';
import {
    accountNumberRegex,
    accountNumberValidation,
    ifscRegex,
    validateIfsc,
} from '../../../../utils/constants';
import { BANK_DETAILS, ValidationUI } from '../../makeNct/MinorStatus/minor-status-edit-bank';
import { FormControl, FormHelperText, MenuItem, Select } from '@material-ui/core';
import TextInput from '../../../../lib/TextField';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import { connect, useDispatch } from 'react-redux';
import { fetchIFSCDetails } from '../../../../redux-store/actions/nct';
import { IfscModal } from '../../../../lib/NoteModals/ifscModal';
import * as yup from 'yup';
import { useHistory } from 'react-router';
import { UPDATE_PURCHASE_INFO } from '../../../../redux-store/types/newPurchase';
import { LoadProfileRoutes } from '.';
import { gettaxStatusPersonal } from '../../portfolios/utils';
import { AccountTypes, AccountTypeLabel } from '../../../../redux-store/types/portfolio';
import { UploadFile } from '../../../../lib/UploadFile.tsx';
import { useState } from 'react';
import { performPennyDropValidation } from '../../../../redux-store/actions/newPurchase';
import { RootStateType } from '../../../../redux-store/reducers';
import { SAVE_CHEQUE_FILE } from '../../../../redux-store/types/commercialTransactions';

const { dashboard, common } = en;

interface BankChange extends BANK {
    ifscInfo: {
        name: string;
        branch: string;
        city: string;
    };
}
type UpdateBankDetailsPurchaseProps = {
    bankDetails: BANK;
};

const VALIDATED_IFSC = 'VALIDATED_IFSC';
const VALIDATED_IFSC_SHOW_POPUP = 'VALIDATED_IFSC_SHOW_POPUP';
const VALIDATION_IFSC_FAILED = 'VALIDATION_IFSC_FAILED';
const VALIDATION_IFSC_PENDING = 'VALIDATION_IFSC_PENDING';

export const initIFSC = {
    name: '',
    branch: '',
    city: '',
};

const validationSchema = yup.object({
    ifsc: yup
        .string()
        .required('IFSC REQUIRED')
        .length(11, common.invalidIFSC)
        .matches(ifscRegex, common.validatingIFSC),
    accountNo: yup
        .string()
        .required('Account Number Required')
        .matches(accountNumberRegex, common.errors.bankErrors.accountNo.regexError),
});

function UpdateBankDetailsPurchase(props: UpdateBankDetailsPurchaseProps & any) {
    const { kfinFlag = false, ...bank } =
        { ...props.location.state.bankDetails, ifscInfo: initIFSC } || {};
    const history = useHistory();
    const dispatch = useDispatch();
    const taxStatus = gettaxStatusPersonal[props.apiData.taxStatus];
    const [cheque, setCheque] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const pennyDropStatus = props?.pennyDropStatus;
    const formik = useFormik<any>({
        // initialValues: { ...bank, accountType: bank.accountType || 'SAVINGS' },
        initialValues: {
            ...bank,
            accountType:
                taxStatus === '01'
                    ? AccountTypes.SAVINGS
                    : taxStatus === '24'
                    ? AccountTypes.NRO
                    : kfinFlag
                    ? bank.accountType || AccountTypes.SAVINGS
                    : AccountTypes.SAVINGS,
        },
        onSubmit: async (values: BankChange) => {
            // const purchaseDetails = props.purchaseDetails || {}
            // const newSchemeDetails = props.newSchemeDetails || {}
            // const isNewToMF = props.newToMF === 'Y'
            // NOTE: Set shouldValidatePennydrop to true to perform penny-drop not just for first-time investors, but all.
            // const didRunPennyValidation = ['Y','N'].includes(pennyDropStatus?.nameMatchStatus)
            // const shouldValidatePennydrop = isNewToMF && !didRunPennyValidation;
            // const shouldValidatePennydrop = true
            // if (shouldValidatePennydrop) {
            //     try {
            //         setLoading(true)
            //         const res = await props.performPennyDropValidation({
            //             investorName: purchaseDetails.investorName || '',
            //             accountNo: values.accountNo,
            //             ifsc: values.ifsc
            //         },
            //             newSchemeDetails.amc || ''
            //         )
            //         const nameMatchStatus = res?.body?.data?.[0].nameMatchStatus
            //         console.log('penny status = ', nameMatchStatus)

            //         const isOkay = nameMatchStatus == 'Y'
            //         console.log(props.newPurchase?.pennyDropStatus)

            //         if (!isOkay) {
            //             return alert('Please upload a cheque!')
            //         }

            //     } catch (error: any) {
            //         console.log(error)
            //         alert(error.message)
            //     } finally {
            //         setLoading(false)
            //     }
            // }

            if (formik.status === VALIDATION_IFSC_FAILED) {
                formik.setFieldError('ifsc', 'Ifsc validation Failed');
                return;
            }
            console.log([{ ...bank, ...values }]);
            dispatch({
                type: UPDATE_PURCHASE_INFO,
                body: { bank: [{ ...bank, ...values }] },
            });
            history.goBack();
        },
        validationSchema,
        initialStatus: null,
        validate: (values: BankChange) => {
            // Making not validated while edited
            // Make only not validated only it success and regex matched
            if (!values.ifsc?.match(ifscRegex) && formik.status === VALIDATED_IFSC) {
                formik.setStatus(null);
                return;
            }
        },
    });
    const { values: newBankDetails } = formik;
    const dipatch = useDispatch();

    const _getIFSCDetails = async (ifsc: string = '') => {
        formik.setFieldValue('ifsc', ifsc.toUpperCase());
        if (!ifsc.match(ifscRegex)) {
            return;
        }
        try {
            formik.setStatus(VALIDATION_IFSC_PENDING);
            let response: any = await dipatch(
                fetchIFSCDetails({
                    ifscCode: ifsc.toUpperCase(),
                }),
            );
            const { errors = [], data = [] } = (response || {}).body;
            if (errors.length) {
                const [firstError] = errors;
                throw Error(firstError?.message);
            }
            const [details] = data;
            const { BankAdd1 = '', BankAdd2 = '', BankAdd3 = '' } = details;
            formik.setStatus(VALIDATED_IFSC_SHOW_POPUP);
            formik.setFieldValue('ifscInfo', {
                ...initIFSC,
                name: details.BankName,
                branch: BankAdd1 || BankAdd2 || BankAdd3,
                city: details.BankCity,
            });
            formik.setFieldValue('branch', BankAdd1 || BankAdd2 || BankAdd3);
            formik.setFieldValue('name', details.BankName);
            formik.setFieldValue('city', details.BankCity);
            formik.setFieldValue('micr', details.MicrNo);
        } catch (e: any) {
            formik.setStatus(VALIDATION_IFSC_FAILED);
            formik.setFieldError('ifsc', 'Ifsc validation failed');
        }
    };

    const onProceed = () => {
        formik.setStatus(VALIDATED_IFSC);
    };

    const onCancel = () => {
        formik.setStatus(VALIDATION_IFSC_FAILED);
        formik.setFieldValue('ifscInfo', initIFSC);
    };

    const a = AccountTypes.SAVINGS;

    const showChequeUploader = props.newToMF === 'Y';
    // console.log('pennydrop status = ', pennyDropStatus)
    console.log('val', newBankDetails);
    return (
        <WhiteLayout header={'Edit Bank Details'} containerClass={'update-pan-selected-content'}>
            <div className="curved-bg-content-inner">
                <div className="add-new-bankAccount">
                    <h4>{dashboard.ChangeBank.selectedFolios.addNewBankHeading}</h4>
                    <p>{dashboard.ChangeBank.selectedFolios.addNewBankHeadingInfo}</p>
                    <div className="new-bank-fields">
                        {(
                            [
                                {
                                    name: 'accountNo',
                                    label: dashboard.ChangeBank.selectedFolios.fields.accountNumber,
                                    value: newBankDetails.accountNo,
                                    isDisabled: false,
                                    fieldValidation: accountNumberValidation,
                                },
                                {
                                    name: 'ifsc',
                                    label: dashboard.ChangeBank.selectedFolios.fields.ifsc,
                                    value: newBankDetails.ifsc,
                                    isDisabled: false,
                                    actionOnBlur: true,
                                    shouldValidateField: true,
                                    fieldValidation: validateIfsc,
                                },
                                {
                                    name: 'name',
                                    label: dashboard.ChangeBank.selectedFolios.fields.bankName,
                                    value: newBankDetails.name,
                                    isDisabled: true,
                                },
                                {
                                    name: 'accountType',
                                    label: dashboard.ChangeBank.selectedFolios.fields.accountType,
                                    value: newBankDetails.accountType,
                                    options: kfinFlag
                                        ? [
                                              {
                                                  label: 'SAVINGS' as AccountTypeLabel,
                                                  value: AccountTypes.SAVINGS,
                                              },
                                              {
                                                  label: 'CURRENT' as AccountTypeLabel,
                                                  value: AccountTypes.CURRENT,
                                              },
                                          ]
                                        : [
                                              {
                                                  label: 'SAVINGS' as AccountTypeLabel,
                                                  value: AccountTypes.SAVINGS,
                                              },
                                          ],
                                    isDisabled: false,
                                },
                                {
                                    name: 'branch',
                                    label: dashboard.ChangeBank.selectedFolios.fields.branch,
                                    value: newBankDetails.branch,
                                    isDisabled: true,
                                },
                                {
                                    name: 'city',
                                    label: dashboard.ChangeBank.selectedFolios.fields.city,
                                    value: newBankDetails.city,
                                    isDisabled: true,
                                },
                            ] as BANK_DETAILS[]
                        ).map((_ele: BANK_DETAILS) =>
                            _ele.name === 'accountType' ? (
                                <FormControl
                                    variant="outlined"
                                    error={Boolean(formik.errors[`${_ele.name}`])}
                                >
                                    <Select
                                        labelId="portfolio-sortby-label"
                                        id="portfolio-sortby"
                                        name={'accountType'}
                                        value={_ele.value}
                                        onChange={formik.handleChange}
                                        readOnly={!kfinFlag}
                                    >
                                        {_ele.options?.map((item) => (
                                            <MenuItem key={item.label} value={item.value}>
                                                {item.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText
                                        className={
                                            Boolean(formik.errors[`${_ele.name}`]) ? 'error' : ''
                                        }
                                    >
                                        {formik.errors[`${_ele.name}`]}
                                    </FormHelperText>
                                </FormControl>
                            ) : (
                                <FormControl variant="outlined">
                                    <TextInput
                                        variant="outlined"
                                        label={_ele.label}
                                        value={_ele.value}
                                        name={_ele.name}
                                        id={_ele.name}
                                        inputProps={
                                            _ele.name === 'accountNo'
                                                ? { inputMode: 'numeric' }
                                                : undefined
                                        }
                                        error={
                                            Boolean(formik.errors[`${_ele.name}`]) &&
                                            !!formik.touched[`${_ele.name}`]
                                        }
                                        helperText={
                                            formik.touched[`${_ele.name}`] &&
                                            formik.errors[`${_ele.name}`]
                                        }
                                        disabled={_ele.isDisabled}
                                        onChange={async (e) => {
                                            //allow backspace
                                            const isBackSpace = e.target.value.length < _ele.value.length;
                                            if (isBackSpace) {
                                                formik.handleChange(e);
                                                return;
                                            }
                                            if (
                                                !!_ele.fieldValidation &&
                                                !_ele.fieldValidation.call({}, e.target.value)
                                            ) {
                                                return;
                                            }
                                            formik.handleChange(e);
                                            if (_ele.name === 'ifsc') {
                                                await _getIFSCDetails(e.target.value);
                                            }
                                        }}
                                        onBlur={formik.handleBlur}
                                    />
                                    <IfscModal
                                        extraClass="ifsc-modal"
                                        showModal={formik.status === VALIDATED_IFSC_SHOW_POPUP}
                                        heading={dashboard.UpdateIFSC.noteModals.pleaseConfirm}
                                        info1={'Bank Name'}
                                        info2={'IFSC Code'}
                                        info3={'City'}
                                        info4={'Branch'}
                                        content1={newBankDetails.ifscInfo?.name}
                                        content2={newBankDetails.ifsc}
                                        content3={newBankDetails.ifscInfo?.city}
                                        content4={newBankDetails.ifscInfo?.branch}
                                        proceedBtn={'Okay'}
                                        onProceed={onProceed}
                                        cancelBtn={'Cancel'}
                                        onCancel={onCancel}
                                    />
                                    {_ele.shouldValidateField &&
                                        [VALIDATION_IFSC_PENDING, VALIDATED_IFSC].includes(
                                            formik.status,
                                        ) && (
                                            <FormHelperText>
                                                <ValidationUI
                                                    isValidating={
                                                        formik.status === VALIDATION_IFSC_PENDING
                                                    }
                                                    onValidationText={common.validatingIFSC}
                                                    successfulValidationText={common.IFSCValidated}
                                                />
                                            </FormHelperText>
                                        )}
                                </FormControl>
                            ),
                        )}

                        {!!showChequeUploader && (
                            <div>
                                {/* <p>
                                    Please upload cheque
                                </p> */}
                                {!!props.chequeFile ? (
                                    <p style={{ color: 'black', fontSize: '18px' }}>
                                        Cheque uploaded : {props.chequeFile?.name}
                                    </p>
                                ) : (
                                    <p>Please upload cheque</p>
                                )}

                                <UploadFile
                                    id={`upload-cheque`}
                                    onImageSelected={(value, format, options) => {
                                        dispatch({
                                            type: SAVE_CHEQUE_FILE,
                                            body: {
                                                chequeFile: !value
                                                    ? null
                                                    : {
                                                          name: options?.name || 'Cheque',
                                                          format: format,
                                                          content: value,
                                                      },
                                            },
                                        });
                                    }}
                                    // imageName={ props.chequeFile?.name || '-select-' }
                                />
                            </div>
                        )}
                    </div>

                    <SubmitButtonWithLoader
                        onClick={formik.submitForm}
                        type="submit"
                        loading={loading}
                        disabled={loading || (!props.chequeFile && showChequeUploader)}
                        className="customBtn "
                        label={'Update'}
                        labelWhileLoading={'Update'}
                    />
                </div>
            </div>
        </WhiteLayout>
    );
}

export default connect(
    ({ authReducer, newPurchase }: RootStateType) => ({ ...authReducer, ...newPurchase }),
    {
        performPennyDropValidation,
    },
)((props: any) => LoadProfileRoutes(props, UpdateBankDetailsPurchase));
